import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { get } from 'lodash';

const PunchInTime = ({
  openEntry,
}) => {
  const [time, setTime] = useState('');
  useEffect(() => {
    const tick = () => {
      const ms = moment().diff(moment(get(openEntry, 'ClockIn')));
      const d = moment.duration(ms);
      setTime(Math.floor(d.asHours()) + moment.utc(ms).format(':mm:ss'));
    };
    const timeInterval = setInterval(tick, 1000);
    return () => {
      clearInterval(timeInterval);
    };
  }, []);
  return (
    <h2>{time}</h2>
  );
};
PunchInTime.propTypes = {
  openEntry: PropTypes.object,
};
PunchInTime.defaultProps = {
  openEntry: {
    ClockIn: '',
    ClockOut: '',
    ActualClockTime: 0,
    ClockTimeHasError: false,
    ClockCardEntryTypeID: 0,
    ClockCardEntryComment: '',
  },
};
export default PunchInTime;



// WEBPACK FOOTER //
// ./src/sites/time/components/PunchInTime.js